import React from 'react';

const CARDS = [
    { num: '01', title: 'Diligence is broken for SMEs', text: '70% of SME investment and exit transactions go undiligenced. Most companies arrive unprepared. Most angel investors lose most of their money.' },
    { num: '02', title: 'AI surfaces 10× more red flags', text: 'New AI tools are surfacing 10× more due diligence red flags — creating more friction for unprepared companies. The gap is about to widen.' },
    { num: '03', title: 'Always-on readiness', text: 'We turned expensive, one-time transaction diligence into continuous readiness — so companies can raise or exit at any point in their lifecycle.' },
];

const AboutWhyExistSection = () => (
    <section className="lp-about-why">
        <div aria-hidden="true" className="lp-about-why-glow lp-about-why-glow--1" />
        <div aria-hidden="true" className="lp-about-why-glow lp-about-why-glow--2" />
        <div className="lp-container">
            <div className="lp-quotes-eyebrow" style={{ display: 'inline-flex' }} data-lp-reveal>Why we exist</div>
            <h2 className="lp-h2" style={{ color: '#fff', marginBottom: 56 }} data-lp-reveal data-lp-delay="60">70% of SME transactions go undiligenced. <span style={{ color: '#FC7785' }}>We're fixing that.</span></h2>

            <div className="lp-about-why-cards">
                {CARDS.map((c, i) => (
                    <div className="lp-about-why-card" key={i} data-lp-reveal data-lp-delay={i * 100}>
                        <div className="num">{c.num}</div>
                        <h3>{c.title}</h3>
                        <p>{c.text}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default AboutWhyExistSection;
